/**
 * **Which survey a task's READ link opens, and under which word.**
 *
 * Two kinds lead into a survey. A submitted survey waiting to be read opens on „Przejrzyj"; a low
 * reading a survey reported (attention-queue R22) opens the check-in it came from, on „Zobacz
 * check-in". Both go to the same place — the client's Ankiety with that occurrence open — so one
 * control draws them (`ui/SurveyLink`) and this is the one place that decides which it is.
 *
 * Pure: no React, no DOM, no query hook, no i18next. What leaves is an id and an i18n KEY.
 */

import type { AttentionItem } from './attentionItems';

export interface SurveyRead {
  readonly surveyAssignmentId: number;
  readonly labelKey: string;
}

export function surveyRead(item: Pick<AttentionItem, 'action' | 'triage'>): SurveyRead | null {
  if (item.action.kind === 'markReviewed') {
    return { surveyAssignmentId: item.action.surveyAssignmentId, labelKey: 'web:tasks.card.reviewSurvey' };
  }
  const vital = item.triage.vital;
  if (vital?.source === 'Survey' && vital.surveyAssignmentId !== null) {
    return { surveyAssignmentId: vital.surveyAssignmentId, labelKey: 'web:tasks.card.openCheckIn' };
  }
  return null;
}
